export class SubmitBody {
  constructor(data) {
    let recaptcha_token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    this.recaptcha_token = recaptcha_token;
    this.data = data;
  }
}